// ========== Route Constants ==========
export const ROUTE_PATHS = {
  HOME: "/",
} as const;

// ========== Types ==========
export interface Sticker {
  id: string;
  emoji: string;
  name: string;
  description: string;
  category: StickerCategory;
  tags: string[];
  bgColor: string;
}

export type StickerCategory =
  | "all"
  | "happy"
  | "love"
  | "funny"
  | "cool"
  | "sleepy"
  | "food"
  | "sports";

export interface CategoryInfo {
  id: StickerCategory;
  label: string;
  emoji: string;
  color: string;
}

// ========== Categories ==========
export const CATEGORIES: CategoryInfo[] = [
  { id: "all", label: "全部", emoji: "🐾", color: "bg-primary/15 text-primary" },
  { id: "happy", label: "开心", emoji: "😄", color: "bg-yellow-100 text-yellow-700" },
  { id: "love", label: "爱心", emoji: "❤️", color: "bg-pink-100 text-pink-700" },
  { id: "funny", label: "搞怪", emoji: "😜", color: "bg-orange-100 text-orange-700" },
  { id: "cool", label: "酷炫", emoji: "😎", color: "bg-blue-100 text-blue-700" },
  { id: "sleepy", label: "困觉", emoji: "😴", color: "bg-purple-100 text-purple-700" },
  { id: "food", label: "吃货", emoji: "🍖", color: "bg-amber-100 text-amber-700" },
  { id: "sports", label: "运动", emoji: "⚽", color: "bg-green-100 text-green-700" },
];

// ========== Sticker Data (32 stickers) ==========
export const STICKERS: Sticker[] = [
  // Happy
  {
    id: "s01",
    emoji: "🐶",
    name: "开心小汪",
    description: "今天也是元气满满的一天！",
    category: "happy",
    tags: ["开心", "活力"],
    bgColor: "#FFF9C4",
  },
  {
    id: "s02",
    emoji: "🥳",
    name: "派对狗狗",
    description: "生日快乐！我来了！",
    category: "happy",
    tags: ["生日", "派对"],
    bgColor: "#FCE4EC",
  },
  {
    id: "s03",
    emoji: "😊",
    name: "微笑柴犬",
    description: "保持微笑，一切都会好的~",
    category: "happy",
    tags: ["笑脸", "积极"],
    bgColor: "#E8F5E9",
  },
  {
    id: "s04",
    emoji: "🎉",
    name: "庆祝汪",
    description: "撒花！撒花！",
    category: "happy",
    tags: ["庆祝", "撒花"],
    bgColor: "#F3E5F5",
  },
  // Love
  {
    id: "s05",
    emoji: "🥰",
    name: "爱心眼汪",
    description: "我喜欢你多一点点~",
    category: "love",
    tags: ["爱心", "喜欢"],
    bgColor: "#FCE4EC",
  },
  {
    id: "s06",
    emoji: "💕",
    name: "双心狗",
    description: "爱意满满溢出来！",
    category: "love",
    tags: ["双心", "爱意"],
    bgColor: "#FFECB3",
  },
  {
    id: "s07",
    emoji: "🐕‍🦺",
    name: "贴贴汪",
    description: "想跟你贴贴~",
    category: "love",
    tags: ["贴贴", "亲密"],
    bgColor: "#E1F5FE",
  },
  {
    id: "s08",
    emoji: "💌",
    name: "情书狗",
    description: "写了一封很长的信给你",
    category: "love",
    tags: ["情书", "浪漫"],
    bgColor: "#FCE4EC",
  },
  // Funny
  {
    id: "s09",
    emoji: "😜",
    name: "吐舌狗",
    description: "Blep! 哈哈哈哈哈",
    category: "funny",
    tags: ["搞怪", "吐舌"],
    bgColor: "#FFF3E0",
  },
  {
    id: "s10",
    emoji: "🤪",
    name: "疯批汪",
    description: "今天也是疯狂星期四！",
    category: "funny",
    tags: ["疯狂", "搞笑"],
    bgColor: "#F3E5F5",
  },
  {
    id: "s11",
    emoji: "😂",
    name: "笑哭汪",
    description: "太好笑了我要翻滚了",
    category: "funny",
    tags: ["笑哭", "幽默"],
    bgColor: "#FFF9C4",
  },
  {
    id: "s12",
    emoji: "🙃",
    name: "倒头狗",
    description: "一切都好，我没事（倒头）",
    category: "funny",
    tags: ["倒头", "摆烂"],
    bgColor: "#E8EAF6",
  },
  // Cool
  {
    id: "s13",
    emoji: "😎",
    name: "墨镜汪",
    description: "Cool 爆了，不接受反驳",
    category: "cool",
    tags: ["墨镜", "帅气"],
    bgColor: "#E3F2FD",
  },
  {
    id: "s14",
    emoji: "🕶️",
    name: "太阳镜",
    description: "夏日出行必备",
    category: "cool",
    tags: ["夏日", "时髦"],
    bgColor: "#E0F7FA",
  },
  {
    id: "s15",
    emoji: "💪",
    name: "健身汪",
    description: "每天锻炼，身材爆炸！",
    category: "cool",
    tags: ["健身", "力量"],
    bgColor: "#FFCCBC",
  },
  {
    id: "s16",
    emoji: "🤙",
    name: "打Call汪",
    description: "你最棒，我为你打Call！",
    category: "cool",
    tags: ["打call", "支持"],
    bgColor: "#E8F5E9",
  },
  // Sleepy
  {
    id: "s17",
    emoji: "😴",
    name: "睡觉狗",
    description: "Zzzzzz... 别叫我起床...",
    category: "sleepy",
    tags: ["睡觉", "困"],
    bgColor: "#EDE7F6",
  },
  {
    id: "s18",
    emoji: "🥱",
    name: "打哈欠",
    description: "又困了，上班好累啊",
    category: "sleepy",
    tags: ["打哈欠", "疲惫"],
    bgColor: "#E8EAF6",
  },
  {
    id: "s19",
    emoji: "😪",
    name: "困困汪",
    description: "困意来袭，挡不住！",
    category: "sleepy",
    tags: ["困", "瞌睡"],
    bgColor: "#F3E5F5",
  },
  {
    id: "s20",
    emoji: "🛌",
    name: "躺平汪",
    description: "今日份躺平，不接受任何打扰",
    category: "sleepy",
    tags: ["躺平", "摸鱼"],
    bgColor: "#E1F5FE",
  },
  // Food
  {
    id: "s21",
    emoji: "🍖",
    name: "啃骨头",
    description: "骨头！是骨头！最爱骨头！",
    category: "food",
    tags: ["骨头", "吃饭"],
    bgColor: "#FFF8E1",
  },
  {
    id: "s22",
    emoji: "😋",
    name: "吃货汪",
    description: "美食当前，先吃为敬！",
    category: "food",
    tags: ["吃货", "美食"],
    bgColor: "#FFECB3",
  },
  {
    id: "s23",
    emoji: "🍕",
    name: "披萨狗",
    description: "pizza is life！",
    category: "food",
    tags: ["披萨", "快乐"],
    bgColor: "#FFCCBC",
  },
  {
    id: "s24",
    emoji: "🧁",
    name: "甜品汪",
    description: "甜甜的，就像你一样~",
    category: "food",
    tags: ["甜品", "可爱"],
    bgColor: "#FCE4EC",
  },
  // Sports
  {
    id: "s25",
    emoji: "⚽",
    name: "足球汪",
    description: "进球啦！庆祝！",
    category: "sports",
    tags: ["足球", "庆祝"],
    bgColor: "#E8F5E9",
  },
  {
    id: "s26",
    emoji: "🏃",
    name: "奔跑狗",
    description: "快跑！追球球！",
    category: "sports",
    tags: ["奔跑", "活力"],
    bgColor: "#E3F2FD",
  },
  {
    id: "s27",
    emoji: "🏊",
    name: "游泳汪",
    description: "水里最快乐！",
    category: "sports",
    tags: ["游泳", "夏天"],
    bgColor: "#E0F7FA",
  },
  {
    id: "s28",
    emoji: "🎾",
    name: "网球狗",
    description: "接住接住接住！",
    category: "sports",
    tags: ["网球", "接球"],
    bgColor: "#F9FBE7",
  },
  // Extra mixed
  {
    id: "s29",
    emoji: "🤔",
    name: "思考汪",
    description: "让我想想……",
    category: "funny",
    tags: ["思考", "认真"],
    bgColor: "#E8EAF6",
  },
  {
    id: "s30",
    emoji: "👻",
    name: "鬼鬼汪",
    description: "哇~ 吓到你了吗？",
    category: "funny",
    tags: ["万圣节", "捣蛋"],
    bgColor: "#F3E5F5",
  },
  {
    id: "s31",
    emoji: "🌟",
    name: "闪耀汪",
    description: "今天也是闪闪发光的一天！",
    category: "happy",
    tags: ["闪耀", "自信"],
    bgColor: "#FFF9C4",
  },
  {
    id: "s32",
    emoji: "🎵",
    name: "音乐狗",
    description: "快乐的歌声停不下来~",
    category: "happy",
    tags: ["音乐", "快乐"],
    bgColor: "#E8F5E9",
  },
];

// ========== Utils ==========
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(" ");
}

export function filterStickers(stickers: Sticker[], category: StickerCategory): Sticker[] {
  if (category === "all") return stickers;
  return stickers.filter((s) => s.category === category);
}
